<template>
  <el-form-item :label="i18nt('designer.setting.activeText')">
    <el-input v-model="activeText"></el-input>
  </el-form-item>
</template>

<script>
import { computed, toRefs } from 'vue';
import { useI18n } from '@/utils/i18n';

export default {
  name: 'activeText-editor',
  props: {
    designer: Object,
    optionModel: Object,
    selectedWidget: Object,
  },
  setup(props) {
    const { i18nt } = useI18n();

    // 为了于PC版统一，activeLabel改成了activeText, 兼容老版本activeLabel
    const activeText = computed({
      get: function () {
        if (props.optionModel.activeLabel !== undefined) {
          return props.optionModel.activeLabel === undefined || props.optionModel.activeLabel === null ? '是' : props.optionModel.activeLabel;
        } else {
          return props.optionModel.activeText === undefined || props.optionModel.activeText === null ? '是' : props.optionModel.activeText;
        }
      },
      set: function (newValue) {
        if (props.optionModel.activeLabel !== undefined) {
          props.optionModel.activeLabel = newValue;
        } else {
          props.optionModel.activeText = newValue;
        }
      },
    });

    return {
      i18nt,
      ...toRefs(props),

      activeText,
    };
  },
};
</script>

<style scoped></style>
